const MapMarkerIcon = () => {
  return <i className="fa fa-map-marker-alt fa-3x text-danger" />;
};

export default MapMarkerIcon;
